<template>
  <el-dialog
      :visible="visible"
      :before-close="close"
      @opened="onOpen"
      width="600px"
      class="viewer"
      :close-on-press-escape="false"
  >

    <div slot="title">
      <div class="el-dialog__title">Новый клиент</div>
      <div class="el-dialog__subtitle">Пожалуйста, внимательно проверьте и заполните информацию о клиенте перед тем как продолжить работу
      </div>
    </div>

    <el-form ref="userForm" class="user-form" :rules="userFormRules" :model="userForm" v-loading="loading">
      <el-form-item label="Телефон" prop="phone" :error="errors.phone | errorToSrt">
        <el-input v-mask="'+7-###-###-##-##'"
                  placeholder="+7-xxx-xxx-xx-xx"
                  auto-complete="off"
                  name="phone"
                  @change="checkUserPhone"
                  v-model="userForm.phone"></el-input>
      </el-form-item>
      <template v-if="!findUsers.length">
        <el-form-item label="Имя" prop="name" :error="errors.name | errorToSrt">
          <el-input v-model="userForm.name"
                    name="name"
                    ref="autoFocus"
                    placeholder="Введите имя клиента"
                    maxlength="255"/>
        </el-form-item>
        <el-form-item label="Пол" prop="gender_id" :error="errors.gender_id | errorToSrt">
          <el-select v-model="userForm.gender_id" class="user-form__select" placeholder="Выберите">
            <el-option
                label="Муж"
                value="1"/>
            <el-option
                label="Жен"
                value="2"/>
          </el-select>
        </el-form-item>

        <el-form-item label="Дата рождения" prop="birthday" :error="errors.birthday | errorToSrt">
          <el-date-picker
              v-model="userForm.birthday"
              class="user-form__date-picker"
              format="dd.MM.yyyy"
              placeholder="Выберите дату"
              type="date"
              :picker-options="pickerOptions"
              value-format="yyyy-MM-dd"
          />
        </el-form-item>
        <el-form-item label="Комментарий" prop="comment" :error="errors.comment | errorToSrt">
          <el-input
              v-model="userForm.comment"
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 8}"
              name="comment"
              maxlength="255"
              placeholder="Напишите короткий комментарий"/>
        </el-form-item>

      </template>
      <footer-buttons>
        <el-button
            type="primary"
            :loading="loadBtn"
            @click="saveForm"
        >Сохранить
        </el-button>
      </footer-buttons>

    </el-form>

    <div v-if="findUsers.length">
      <p>Клиент с таким тефонным номером уже есть в системе</p>
      <userList :users="findUsers" mini @openUser="goUser"/>
    </div>

  </el-dialog>
</template>

<script>
import moment from "moment"
import UserList from "@/components/elements/UserList/UserList"
import FooterButtons from "@/components/dialog/FooterButtons"

export default {
  name: "TheNewUserDialog",
  data() {
    return {
      form: null,
      error: null,
      loading: false,
      loadBtn: false,
      findUsers: [],
      errors: {},
      userForm: {},
      userFormRules: {
        name: [
          {required: true, message: 'Укажите имя', trigger: 'blur'}
        ],
        gender_id: [{required: true, message: 'Укажите пол', trigger: 'blur'}],
        phone: [{
          required: true,
          message: "Укажите номер",
          trigger: "blur"
        },
          {
            min: 16,
            max: 16,
            message: "Введите все цифры номера",
            trigger: "blur",
          },
        ],
        birthday: [
          {required: true, message: 'Укажите дату', trigger: 'blur'}
        ]
      },
      pickerOptions: {
        disabledDate(time) {
          let date = moment().subtract(18, 'y').valueOf()
          return time.getTime() > date
        },
        defaultValue: moment().subtract(18, 'y').valueOf(),
      }
    }
  },
  props: {
    visible: {
      required: true,
    }
  },
  filters: {
    errorToSrt(t) {
      return t ? t.join(', ') : null
    }
  },
  computed: {},
  components: {
    UserList,
    FooterButtons
  },
  methods: {
    onOpen() {

    },

    close() {
      this.userForm = {}
      this.findUsers = []
      this.$refs.userForm.clearValidate()
      this.$emit('close')
    },
    checkUserPhone() {

      let payLoad = {...this.userForm}

      let params = {
        params: {
          phone: payLoad.phone.replace(/[^\d]/g, '')
        },
      }

      this.$api.user.checkPhone(params)
          .then((response) => {
            this.findUsers = response.data

            if (response.data.length) {
              this.$notify.success({
                title: 'Нашелся пользователь',
                message: 'Найден пользователь с данным номером'
              })
            } else {
              this.$notify.success({
                title: 'Проверка пройдена',
                message: 'Пользователь с данным номером не найден'
              })
            }
          })
          .catch((response) => {
            this.$notify.error({
              title: 'Ошибка проверки номера',
              message: response.response.data.message
            })
          })
          .finally(() => {

          })

    },
    goUser(user) {
      this.$emit('created', user)
      this.close()
    },
    saveForm() {
      this.$refs.userForm.validate((valid) => {
        if (valid) {
          this.loadBtn = true

          let payLoad = {...this.userForm}
          payLoad.phone = payLoad.phone.replace(/[^\d]/g, '')

          this.$api.user.create(payLoad)
              .then((response) => {
                this.$notify.success({
                  title: 'Успешно',
                  message: 'Новый пользователь создан'
                })

                this.goUser(response.data)
              })
              .catch((response) => {
                this.$notify.error({
                  title: 'Ошибка',
                  message: response.response.data.message
                })
              })
              .finally(() => {
                this.loadBtn = false
              })
        }
      })

    }


  }
};
</script>

<style scoped lang="scss">

.user-form {
  margin-top: 24px;

  &__select, &__date-picker {
    width: 100%;
  }

  &__btn {
    margin-bottom: 14px;
  }
}

/deep/ .el-textarea__inner {
  line-height: 28px;
  font: 400 12px Arial !important;

}
</style>

